/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'
import { SystemStyleFunction } from '@chakra-ui/theme-tools'

const variantTooltip: SystemStyleFunction = () => ({
  body: {
    borderRadius: 'md', // 6px
    boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, 0.12)',
    color: 'gray.800',
    fontSize: 'xs', // 12px
    lineHeight: '20px',
    paddingX: 4,
    paddingY: 3,
  },
  content: {
    backgroundColor: 'gray.0',
    borderWidth: '1px',
    borderColor: 'gray.100',
    borderRadius: 'md',
    width: 'auto',
    maxWidth: 300,
  },
})

const variants = {
  tooltip: variantTooltip,
}

export const Z4Popover: ComponentStyleConfig = {
  baseStyle: {},
  defaultProps: {
    size: 'sm',
  },
  variants,
}
